const getOrderType = (order) => {
  if (!order) {
    return "";
  }

  return order?.OrderType;
};

export default getOrderType;
